import { Locale } from '@interdan/public-ui';

import { LOCALE } from '^configs/environments';
import TTexts from '^types/common/TTexts';

import DK from './dk';
import SE from './se';

const texts: Record<Locale, TTexts> = {
  [Locale.DK]: DK,
  [Locale.SE]: SE,
};

export default texts[LOCALE];

